import { formatDate } from '../../../../shared/datetime'

/**
 * Die Laufzeit eines Projekts als ein Satz.
 *
 * Ein Projekt läuft über Monate — „Wartung und Kleinentwicklung 2025/26" über
 * ein ganzes Schuljahr. Ein einzelnes Datum konnte davon nur das Ende
 * festhalten; seit es Beginn und Ende gibt, steht die Spanne an jeder Stelle
 * gleich da.
 *
 * Fehlt eine der beiden Angaben, steht nur die vorhandene — „ab 1.9.2025"
 * sagt mehr als ein Bindestrich, hinter dem nichts kommt.
 */
const datum = value => formatDate(value)

// `project` darf null sein — an einer Anforderung ohne Projekt steht dort
// nichts, und der Aufruf soll deshalb nicht abbrechen.
export default function laufzeitText(project) {
	const von = datum(project?.startDate)
	const bis = datum(project?.endDate)

	if (von && bis) return `${von} – ${bis}`
	if (von) return `ab ${von}`
	if (bis) return `bis ${bis}`

	return ''
}
